import React from 'react';
import { _t } from 'utils';
import Section from 'screens/shared/section';
import { useSelector } from 'react-redux';
import { form } from 'types/form';
import { ACTIONS_TYPES } from 'redux/helper';
import { VALIDATION } from 'constant';
import { actions } from 'redux/actions';
import { withRouter } from 'react-router-dom';

export default withRouter(({ match }) => {
  const { dcId, id: serverId } = match?.params;

  const { [ACTIONS_TYPES.SERVER.GET]: server = {} } = useSelector((e) => e);
  const { properties: serverProps = {}, entities = {} } = server;
  const bootDevice = { ...serverProps?.bootCdrom, ...serverProps?.bootVolume };
  const isBootDevice = !!bootDevice?.properties?.name;

  const fields = [
    {
      name: 'bootDevice',
      type: 'boot',
      title: _t('Name'),
      options: [
        ...(entities?.volumes?.items || []),
        ...(entities?.cdroms?.items || []),
      ],
    },
  ];

  const validations = [
    {
      name: 'bootDevice',
      type: VALIDATION.REQUIRED,
    },
  ];

  const onSave = (e) => {
    const { type, id } = e.bootDevice;
    const props = {};
    if (type === 'image') props.bootCdrom = { id };
    else props.bootVolume = { id };

    actions.server.update({ dcId, id: serverId, properties: props });
  };


  return (
    <Section
      sectionTitle={_t('Boot Device')}
      itemIcon="compact-disc"
      className="p-t-15"
      setItemIconText={() => 'Boot'}
      itemIconColor="var(--color-success)"
      setItemTitle={(e) => e?.properties?.name}
      setItemDetails={(e) => `${e?.properties?.size} GB`}
      createForm={form({
        fields,
        fieldsValues: { bootDevice },
        onSubmit: onSave,
        isCancel: false,
        validations,
      })}
      items={isBootDevice ? [bootDevice] : []}
      itemOnEdit={onSave}
      createActionType={ACTIONS_TYPES.SERVER.UPDATE}
      isAddButton={!isBootDevice}
    />
  );
});
